var RouterApi = /** @class */ (function () {
    function RouterApi(router, history) {
        var _this = this;
        this.router = router;
        this.history = history;
        this.block = function (prompt) {
            _this.router.block(prompt);
        };
        this.unblock = function () {
            _this.router.unblock();
        };
        this.isBlocked = function () {
            return _this.router.isBlocked();
        };
        this.goTo = function (name, params, query) {
            _this.history.push(_this.router.resolvePath(name, params, query));
        };
        this.goBack = function () {
            _this.history.goBack();
        };
        this.replace = function (name, params, query) {
            _this.history.replace(_this.router.resolvePath(name, params, query));
        };
        this.resolvePath = function (name, params, query) {
            return _this.router.resolvePath(name, params, query);
        };
        this.resolveAbsolutePath = function (name, params, query) {
            return "" + window.location.origin + _this.resolvePath(name, params, query);
        };
        this.resolveRoute = function (url) {
            return _this.router.resolveRoute(url);
        };
        this.isActive = function (name) {
            return _this.router.getCurrentMatch().isRouteActive(name);
        };
        this.isAllow = function (name, params, query) {
            return _this.router.isRouteAllow(name, params, query);
        };
        this.getQuery = function () {
            return _this.router.getCurrentMatch().getQuery();
        };
        this.getParams = function () {
            return _this.router.getCurrentMatch().getParams();
        };
        this.getName = function () {
            return _this.router.getCurrentMatch().getName();
        };
        this.getResourceName = function () {
            return _this.router.getCurrentMatch().getResourceName();
        };
        this.match = function (matchRecords) {
            return _this.router.getCurrentMatch().match(function (name) { return matchRecords[name]; });
        };
    }
    return RouterApi;
}());
export { RouterApi };
//# sourceMappingURL=RouterApi.js.map